// Single place to control the GameAway wind-down.
// Change SHUTDOWN_DATE_TEXT / SHUTDOWN_DATE together.

export const SHUTDOWN_DATE_TEXT = "15 November 2026";
export const SHUTDOWN_DATE = new Date("2026-11-15T23:59:59+05:30");
export const SUPPORT_EMAIL = "support@gameaway.in";

// New signups and all purchases are closed from the moment this ships.
export const SIGNUPS_CLOSED = true;
export const PURCHASES_CLOSED = true;

export const isAfterShutdown = () => Date.now() > SHUTDOWN_DATE.getTime();
